import type {
  BetterstartIntegrationDefinition,
  BetterstartIntegrationId
} from '@integration-engine/types.js'
import { mailchimpIntegration } from '@next-adapter/integrations/mailchimp/integration.js'
import { r2Integration } from '@next-adapter/integrations/r2/integration.js'
import { railwayBucketIntegration } from '@next-adapter/integrations/railway-bucket/integration.js'
import { resendIntegration } from '@next-adapter/integrations/resend/integration.js'
import { vercelBlobIntegration } from '@next-adapter/integrations/vercel-blob/integration.js'

export const integrationRegistry: Record<string, BetterstartIntegrationDefinition> = {
  mailchimp: mailchimpIntegration,
  resend: resendIntegration,
  r2: r2Integration,
  'railway-bucket': railwayBucketIntegration,
  'vercel-blob': vercelBlobIntegration
}

export function listIntegrationDefinitions(): BetterstartIntegrationDefinition[] {
  return Object.values(integrationRegistry)
}

export function getIntegrationDefinition(
  integrationId: BetterstartIntegrationId
): BetterstartIntegrationDefinition {
  const definition = integrationRegistry[integrationId]
  if (!definition) {
    throw new Error(formatUnknownIntegrationMessage([integrationId]))
  }
  return definition
}

export function isIntegrationId(value: string): value is BetterstartIntegrationId {
  return value in integrationRegistry
}

export function isEmailProviderIntegration(integrationId: BetterstartIntegrationId): boolean {
  return Boolean(getIntegrationDefinition(integrationId).capabilities?.emailProvider)
}

export function formatUnknownIntegrationMessage(integrationIds: string[]): string {
  return `Unknown integration(s): ${integrationIds.join(', ')}. Available for next: ${Object.keys(integrationRegistry).join(', ')}`
}
